var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Fuse from 'fuse.js';
const highlight = (text, indices) => {
    if (!indices)
        return text;
    var content = '', nextUnhighlightedRegionStartingIndex = 0;
    indices.forEach(function (region) {
        content +=
            '' +
                text.substring(nextUnhighlightedRegionStartingIndex, region[0]) +
                '<span class="highlight">' +
                text.substring(region[0], region[1] + 1) +
                '</span>' +
                '';
        nextUnhighlightedRegionStartingIndex = region[1] + 1;
    });
    content += text.substring(nextUnhighlightedRegionStartingIndex);
    return content;
};
const highlightResults = (results) => {
    return results.map((result) => (Object.assign(Object.assign({}, result.item), result.matches.reduce((acc, match) => (Object.assign(Object.assign({}, acc), { [match.key]: highlight(match.value, match.indices) })), {}))));
};
const fuzzySearch = (_a) => {
    var { data, keys, searchTerm } = _a, rest = __rest(_a, ["data", "keys", "searchTerm"]);
    const fuse = new Fuse(data, Object.assign(Object.assign({ shouldSort: true, matchAllTokens: true, tokenize: true, threshold: 0.26, location: 0, distance: 255, maxPatternLength: 32, minMatchCharLength: 3, keys }, rest), { 
        // This needs to be enabled
        includeMatches: true }));
    const results = fuse.search(searchTerm);
    const highlightedResults = highlightResults(results);
    return highlightedResults;
};
export { fuzzySearch };
//# sourceMappingURL=fuzzySearch.js.map